import { axios } from "../../../packs/axios";

export const campaignAPI = {
  /**
   * Post Create Campaign with Segments
   * @constructor
   * @param {number} campaignId - The Campaign ID
   * @param {string} clickType - The type of click (campaign_click // no_campaign_click)
   * @returns {object} {edit_path: ""} containing URL edit_path to redirect the user to
  **/
  postCreateCampaignWithSegments(campaignId, clickType){
    return axios.post(`/api/v3/campaigns/${campaignId}/create_campaign_with_segments?click_type=${clickType}`).then(resp => resp.data);
  }
}